import { render } from "./TransitionRouterView.vue?vue&type=template&id=7a44012a"
const script = {}

import "./TransitionRouterView.vue?vue&type=style&index=0&id=7a44012a&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__